module.exports = __webpack_public_path__ + "img/toDevis.e476fd39.png";